import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const useCastAndCrewLayoutType = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isList = searchParams.get('layout') === 'list';

  const handleViewChange = useCallback(() => {
    setSearchParams((prev) => {
      const isList = prev.get('layout') === 'list';
      const updated = new URLSearchParams(prev.toString());
      updated.delete('cast-page');
      if (isList) {
        updated.delete('layout');
      } else {
        updated.set('layout', 'list');
      }
      return updated;
    });
  }, [setSearchParams]);

  return useMemo(() => {
    return {
      layout: isList ? 'list' : 'grid',
      handleViewChange,
    };
  }, [handleViewChange, isList]);
};

export default useCastAndCrewLayoutType;
